import api, { API_BASE_URL } from './client';
import type { LoginCredentials, AuthResponse, User, OAuthSettings, MeResponse } from './types';

/**
 * Auth API
 * Håndterer autentisering, login, logout og OAuth
 */
export const authAPI = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token: string, password: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/reset-password', { token, password });
    return response.data;
  },

  getCurrentUser: async (): Promise<MeResponse> => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
    // Cookie is cleared by backend
  },

  // OAuth Account Linking
  linkGoogle: (): void => {
    // Redirect til OAuth linking endpoint
    window.location.href = `${API_BASE_URL}/auth/link-google`;
  },

  linkFacebook: (): void => {
    // Redirect til OAuth linking endpoint
    window.location.href = `${API_BASE_URL}/auth/link-facebook`;
  },

  unlinkProvider: async (provider: 'google' | 'facebook'): Promise<{ message: string; user: User }> => {
    const response = await api.delete(`/auth/unlink/${provider}`);
    return response.data;
  },

  getOAuthSettings: async (): Promise<{ settings: OAuthSettings }> => {
    const response = await api.get('/auth/oauth-settings');
    return response.data;
  },
};

